import { render } from "./LauncherWidgetComponent.vue?vue&type=template&id=9f70e8ec&scoped=true"
import script from "./LauncherWidgetComponent.vue?vue&type=script&lang=js"
export * from "./LauncherWidgetComponent.vue?vue&type=script&lang=js"

import "./LauncherWidgetComponent.vue?vue&type=style&index=0&id=9f70e8ec&lang=scss&scoped=true"

import exportComponent from "E:\\dive\\dive.fsd.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f70e8ec"]])

export default __exports__